import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useLoginFormState() {
  return useAppState();
}

export function useLoginFormActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      loginForm: {
        email: '',
        password: '',
      },
    }));
  }

  function updateEmail(email) {
    dispatch((state) => ({
      ...state,
      loginForm: {
        ...state.loginForm,
        email,
      },
    }));
  }

  function updatePassword(password) {
    dispatch((state) => ({
      ...state,
      loginForm: {
        ...state.loginForm,
        password,
      },
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    updateEmail,
    updatePassword,
    onResponse,
    onError,
    clearFeedback,
  };
}
